<template>
  <b-modal size="md" v-model="show" centered :title="'Vorgaben'"
  >
    <b-row>
      <b-col>
        <h4>Allgemein</h4>
        <b-form-checkbox
            v-model="showClosed"
            :value="true"
            :unchecked-value="false"
        >
          Geschlossene Aufträge anzeigen ?
        </b-form-checkbox>
        <b-form-checkbox
            v-model="showLegr"
            :value="true"
            :unchecked-value="false"
        >
          Leistungs- Unteraufträge anzeigen ?
        </b-form-checkbox>
        <h4 class="mt-3">Erweitert</h4>
        <b-form-checkbox
            v-model="zwtKreislauf"
            :value="true"
            :unchecked-value="false"
            class="mb-3"
        >
          Ausgaben aufteilen ?
        </b-form-checkbox>
        <b-form-checkbox
            v-model="useAnehmer"
            :value="true"
            :unchecked-value="false"
            class="mb-2"
        >
          Auftragnehmer verwenden ?
        </b-form-checkbox>
        <label v-if="useAnehmer" for="annehmer">Auftragnehmerbezeichnung</label>
        <b-form-select v-if="useAnehmer" :options="anehmer_name_select" id="annehmer" :plain="true"
                       v-model="anehmerName"
                       class="text-black mb-3"
        ></b-form-select>
        <b-form-checkbox
            v-model="useKombi"
            :value="true"
            :unchecked-value="false"
            class="mb-2"
        >
          Kombifeld verwenden ?
        </b-form-checkbox>
        <label for="name" v-if="useKombi">Kombifeldname</label>
        <b-form-input v-if="useKombi" id="name" type="text"
                      v-model="kombiName"
                      class="mb-2 text-black"
                      maxlength="15"
        ></b-form-input>
        <b-form-text v-if="useKombi" style="text-align: right">{{kombiName.length}}/15</b-form-text>
        <label for="name">Maske Kontoanlage</label>
        <b-form-input id="name" type="text"
                      v-model="maskKonto"
                      class="mb-2 text-black"
                      placeholder="z.B. 99.99999;99999XX"
        ></b-form-input>
        <b-form-text style="text-align: left">9: Zahl; X: Buchstabe; Sonderzeichen direkt eingeben</b-form-text>
        <label for="name" class="mt-2">Erläuterungen: Maske Kontoanlage</label>
        <b-form-input id="name" type="text"
                      v-model="descKonto"
                      class="mb-2 text-black"
                      placeholder="z.B. {Kontenart}.{Konto};{Unterkonto}{Kennzeichen}"
        ></b-form-input>
        <h5 class="mt-3">Mehrwertsteuer</h5>
        <b-row v-if="show">
          <b-col>
            <b-form-checkbox
                v-model="mwsts[0].value_2"
                :value="'true'"
                :unchecked-value="'false'"
                class="mb-3"
            >
              7%
            </b-form-checkbox>
            <b-form-checkbox
                v-model="mwsts[1].value_2"
                :value="'true'"
                :unchecked-value="'false'"
                class="mb-3"
            >
              19%
            </b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox
                v-model="mwsts[2].value_2"
                :value="'true'"
                :unchecked-value="'false'"
                class="mb-3"
            >
              10%
            </b-form-checkbox>
            <b-form-checkbox
                v-model="mwsts[3].value_2"
                :value="'true'"
                :unchecked-value="'false'"
                class="mb-3"
            >
              13%
            </b-form-checkbox>
            <b-form-checkbox
                v-model="mwsts[4].value_2"
                :value="'true'"
                :unchecked-value="'false'"
                class="mb-3"
            >
              20%
            </b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox
                v-model="mwsts[5].value_2"
                :value="'true'"
                :unchecked-value="'false'"
                class="mb-3"
            >
              <b-form-input id="name" type="number"
                            v-model="mwsts[5].value_1"
                            class="mb-2 text-black"
              ></b-form-input>
            </b-form-checkbox>
            <b-form-checkbox
                v-model="mwsts[6].value_2"
                :value="'true'"
                :unchecked-value="'false'"
                class="mb-3"
            >
              <b-form-input id="name" type="number"
                            v-model="mwsts[6].value_1"
                            class="mb-2 text-black"
              ></b-form-input>
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
        <template #modal-footer="{ok, cancel}">
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button size="md" variant="primary" @click="onCancel">
            Abbrechen
          </b-button>
          <b-button size="md" variant="success" @click="onSave">
            Speichern
          </b-button>
        </template>
  </b-modal>
</template>

<script>
export default {
  name: "SettingsDialog",
  props: {
    settings: {
      type: Object,
      default: () => {
        return {
          showClosed: false,
          showLegr: true,
          zwtKreislauf: false,
          useAnehmer: false,
          anehmerName: 'Kunde',
          useKombi: false,
          kombiName: 'Kommune',
          maskKonto: '',
          descKonto: '',
          mwsts: [],
        };
      }
    },
  },
  data() {
    return {
      show: false,
      showClosed: false,
      showLegr: true,
      anehmer_name_select: ['Auftragnehmer', 'Kunde', 'Ortsteil'],
      zwtKreislauf: false,
      useAnehmer: false,
      anehmerName: 'Ortsteil',
      useKombi: false,
      kombiName: 'Kommune',
      maskKonto: '',
      descKonto: '',
      mwsts: [],
    }
  },
  methods: {
    onSave() {
      this.show = false;
      this.$emit("save-settings", this.getReturnData());
    },
    onCancel() {
      this.show = false;
    },
    showDialog() {
      this.showLegr = this.settings.showLegr;
      this.showClosed = this.settings.showClosed;
      this.zwtKreislauf = this.settings.zwtKreislauf;
      this.useAnehmer = this.settings.useAnehmer;
      this.anehmerName = this.settings.anehmerName;
      this.useKombi = this.settings.useKombi
      this.kombiName = this.settings.kombiName;
      this.maskKonto = this.settings.maskKonto;
      this.descKonto = this.settings.descKonto;
      this.mwsts = this.settings.mwsts;
      this.show = true;
    },
    getReturnData: function () {
      return {
        showClosed: this.showClosed,
        showLegr: this.showLegr,
        zwtKreislauf: this.zwtKreislauf,
        useAnehmer: this.useAnehmer,
        anehmerName: this.anehmerName,
        useKombi: this.useKombi,
        kombiName: this.kombiName,
        maskKonto: this.maskKonto,
        descKonto: this.descKonto,
        mwsts: this.mwsts,
      }
    },
  }
}
</script>

<style scoped>

</style>
